var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgElSalvador(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1200pt",
    height: "1200pt",
    viewBox: "0 0 1200 1200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m910.8 535.2-32.402-9.5977-24-7.2031-42 3.6016-9.5977 24-9.6016 20.398-31.199-18-7.1992-26.398-31.199-34.801-49.203-8.3984-45.598 6-24-24-27.602-9.6016-7.1992-10.801-40.801-8.3984-61.199 40.801v24l-43.199 12-58.801 12-46.801 44.398-1.1992 22.801-18 25.199 21.602 7.1992h48l39.598 33.602 56.402 10.801 27.598-1.1992 82.801 33.598 78 38.402 10.801-19.203-34.801-18 16.801-9.5977 44.398 1.1992 37.199 45.602 26.402 20.398 110.4 1.1992 32.402-39.598-13.203-20.402 15.602-13.199-6-20.398 12-33.602-6-16.801 10.801-42v-36"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElSalvador);
export default __webpack_public_path__ + "static/media/elSalvador.4c0b1600cd85b764591fca5e5fcf775c.svg";
export { ForwardRef as ReactComponent };